import React from 'react';
import PropTypes from 'prop-types';
import { DropdownLight } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../context/useAppContext';

export default function CurrencySelector({ value, onChange, disabled = false }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    const currencies = React.useMemo(() => {
        let _currencies = [
            { value: 'EUR', label: t('currencies.label.eur') },
            { value: 'CHF', label: t('currencies.label.chf') },
            { value: 'GBP', label: t('currencies.label.gbp') },
            { value: 'CAD', label: t('currencies.label.cad') },
            { value: 'USD', label: t('currencies.label.usd') }
        ];

        // List ID_ORGA to activate ZAR currencie
        const orgalist = [545017, 544928, 552970, 568725, 637931, 637933, 637935, 637937, 637939, 637941, 637943, 637945, 637947, 637949];

        if (orgalist.includes(organization.id)) {
            _currencies.push({ value: 'ZAR', label: t('currencies.label.zar') });
        }

        return _currencies;
    }, [organization, t]);

    return <DropdownLight value={value} onChange={onChange} items={currencies} disabled={disabled} />;
}

CurrencySelector.propTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired
};
